export default "__VITE_ASSET__dfdea4e4__"